import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { loginConstants } from "@/components/LoginPage/login.constants";

const openAPIAuthState = () => ({
    baseURL: process.env.VUE_APP_BASE_URL,
    termsPrivacyURLs: '',
});

const openAPIAuthMutations = {
    [storeMutation.setTermsPrivacyURLs]: (state, data) => {       
        state.termsPrivacyURLs = data;
    },
};

const openAPIAuthActions = {
    [storeAction.loginPrivacyTermsOfUse]: wrapAction(storeAction.loginPrivacyTermsOfUse, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}openapi/api/get-open-resources-urls`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTermsPrivacyURLs, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const openAPIAuthGetters = {
    [storeGetters.termsPrivacyURLs]: state => state.termsPrivacyURLs,
    [storeGetters.cookiePolicyUrl]: (state) => {
        let cookieUrl = loginConstants.externalLinks.cookiePolicy.LINK;
        if (state.termsPrivacyURLs && state.termsPrivacyURLs.length) {
            const cookiePolicyObject = state.termsPrivacyURLs
                .find(item => item.name && item.name.toLowerCase() === 'cookie policy');
            cookieUrl = cookiePolicyObject && cookiePolicyObject.navigationUrl
                ? cookiePolicyObject.navigationUrl
                : loginConstants.externalLinks.cookiePolicy.LINK;
        }
        return cookieUrl;
    },
};
export default {
    namespaced: true,
    state: {
        ...openAPIAuthState(),
    },
    mutations: { ...openAPIAuthMutations },
    actions: { ...openAPIAuthActions },
    getters: { ...openAPIAuthGetters },
};
